exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-menu-item[data-v-5efd8bae] {\n\tfont-size: 12px;\n}\n", ""]);

// exports
